/**
 * Partenaires affichés sur la page /partenaires.
 * N'ajoutez un partenaire qu'avec un accord signé et son autorisation d'utiliser son nom et son logo :
 *   { name: 'Nom', type: 'Institution de microfinance', description: 'Rôle dans le partenariat', logo: import ou null, website: 'URL' ou null, since: 2026 }
 * Logo : fichier PNG ou SVG à fond transparent dans src/assets/partenaires/, importé en haut de ce fichier
 *   (ex. import logoExemple from '../assets/partenaires/exemple.png'). Dès le premier partenaire, ses
 *   logos défilent sur la page Partenaires (à la place des emplacements « Votre logo ici ») et sur l'accueil.
 */
export const PARTNERS = [];

/** Types de partenaires recherchés (pages Partenaires et Devenir partenaire) */
export const PARTNER_TYPES = [
  { title: 'ONG et associations', text: 'Repérer des porteurs de projet, les accompagner et suivre l\'impact dans les communautés.' },
  { title: 'Institutions de microfinance et banques', text: 'Compléter le financement participatif et proposer des services aux entrepreneurs.' },
  { title: 'Entreprises', text: 'Soutenir des projets de votre filière, offrir des débouchés ou du mécénat de compétences.' },
  { title: 'Collectivités et institutions', text: 'Relayer les projets locaux et partager les données d\'impact de leur territoire.' }
];
